"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const get_generator_function_1 = require("../get-generator-function");
const functions_1 = __importDefault(require("../functions"));
const generator_functions_1 = require("../parsers/generator-functions");
const getParentIds = (allValues, childId, soFar = []) => {
    var _a;
    const parentId = (_a = allValues.find((v) => v.id === childId)) === null || _a === void 0 ? void 0 : _a.parentId;
    return parentId ? getParentIds(allValues, parentId, [parentId, ...soFar]) : soFar;
};
function unwrap(wrappedState) {
    return Object.fromEntries(Object.entries(wrappedState)
        .map(([key, value]) => [key, value.value]));
}
const actionsById = [
    "refresh",
    "update",
    "updatePresets",
];
const setFieldByString = (obj, fieldString, value) => {
    var _a;
    const [field, ...nestedFields] = fieldString.split('.');
    if (nestedFields.length === 0)
        return Object.assign(Object.assign({}, obj), { [field]: value });
    return Object.assign(Object.assign({}, obj), { [field]: setFieldByString((_a = obj[field]) !== null && _a !== void 0 ? _a : {}, nestedFields.join('.'), value) });
};
function snapshotManager(generatorSpecs, initialPresets = {}, transforms = {}, typeSpecs = {}, genFunctionSpecs = {}, generatorConfigs = []) {
    const specs = Array.isArray(generatorSpecs) ? generatorSpecs : [generatorSpecs];
    let snapshotPresets = initialPresets;
    let snapshotIndex = 0;
    const stateGetters = specs.map((spec) => (0, get_generator_function_1.getGeneratorFunction)(spec.values.map((v) => (Object.assign(Object.assign({}, v), { rules: v.rules[0] }))), {
        valueTypeSpecs: typeSpecs,
        valueFunctionSpecs: genFunctionSpecs,
        valueFunctions: functions_1.default,
        systemFunctions: generator_functions_1.generatorFunctions,
    }));
    const getTransformedState = (presets = {}, updatedValues = {}, oldValues = {}) => {
        var _a, _b, _c;
        const { _generatorConfig = [] } = presets !== null && presets !== void 0 ? presets : {};
        const getterPoolLength = _generatorConfig.length || stateGetters.length;
        const generatorIndex = Math.floor(Math.random() * getterPoolLength);
        const result = ((_c = stateGetters[_generatorConfig.length > 0
            ? (_b = (_a = _generatorConfig[generatorIndex]) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : generatorIndex
            : generatorIndex]) !== null && _c !== void 0 ? _c : stateGetters[0])(updatedValues, oldValues);
        applyTransforms(result.state);
        return {
            state: Object.assign(Object.assign(Object.assign({}, result.state), presets), { _errors: result.errors }),
        };
    };
    const applyTransforms = (state) => {
        Object.entries(transforms).forEach(([prop, valueName]) => {
            let value = state;
            for (const field of valueName.split('.')) {
                value = value[field];
            }
            state[prop] = value;
        });
    };
    let snapshots = [];
    const commonPresets = Object.assign(Object.assign({}, snapshotPresets), { _snapshotVersion: 1 });
    if (generatorConfigs.length) {
        snapshots = generatorConfigs.map((_generatorConfig) => getTransformedState(Object.assign(Object.assign({}, commonPresets), { _snapshotId: (0, uuid_1.v4)(), _generatorIsRandom: false, _generatorConfig: _generatorConfig.types })));
    }
    else {
        snapshots = [
            getTransformedState(Object.assign(Object.assign({}, commonPresets), { _snapshotId: (0, uuid_1.v4)(), _generatorIsRandom: true, _generatorConfig: [
                    {
                        type: Math.floor(Math.random() * Object.keys(generatorSpecs).length),
                        levels: [0],
                    }
                ] }))
        ];
    }
    const getIndex = (id) => snapshots.findIndex((ss) => ss.state._snapshotId === id);
    const actions = {
        copy: (id) => {
            const index = getIndex(id);
            if (index !== -1) {
                snapshots.push(getTransformedState({}, Object.assign(Object.assign({}, (snapshots[index].state)), { _snapshotId: (0, uuid_1.v4)() }), { state: {} }));
                snapshotIndex = snapshots.length - 1;
            }
        },
        delete: (id) => {
            const index = getIndex(id);
            if (index !== -1 && snapshots.length > 1) {
                snapshots.splice(index, 1);
                snapshotIndex = Math.min(snapshots.length - 1, index);
            }
        },
        go: (index) => {
            if (index > -1 && index < snapshots.length)
                snapshotIndex = index;
        },
        new: (actionPresets = {}, genConfigs = []) => {
            var _a, _b, _c;
            snapshotIndex = snapshots.length;
            let _generatorIsRandom = false;
            let _generatorConfig = (_b = (_a = genConfigs.find((gc) => gc.index === snapshotIndex)) === null || _a === void 0 ? void 0 : _a.types) !== null && _b !== void 0 ? _b : (_c = generatorConfigs.find((gc) => gc.index === snapshotIndex)) === null || _c === void 0 ? void 0 : _c.types;
            if (!_generatorConfig) {
                _generatorIsRandom = true;
                _generatorConfig = [
                    {
                        type: Math.floor(Math.random() * Object.keys(generatorSpecs).length),
                        levels: [0],
                    }
                ];
            }
            const presets = Object.assign(Object.assign(Object.assign({}, snapshotPresets), actionPresets), { _snapshotId: (0, uuid_1.v4)(), _snapshotVersion: 1, _generatorConfig,
                _generatorIsRandom });
            snapshots.push(getTransformedState(presets));
        },
        newSet: (numberOfSnapshots = 5) => {
            var _a, _b, _c;
            const newSnapshots = [];
            for (let i = 0; i < Math.max(1, numberOfSnapshots); i++) {
                let { _generatorIsRandom = false, _generatorConfig, _snapshotId, _snapshotVersion } = (_b = (_a = snapshots[i]) === null || _a === void 0 ? void 0 : _a.state) !== null && _b !== void 0 ? _b : {};
                _generatorConfig = _generatorConfig !== null && _generatorConfig !== void 0 ? _generatorConfig : (_c = generatorConfigs.find((gc) => gc.index === i)) === null || _c === void 0 ? void 0 : _c.types;
                if (!_generatorConfig || _generatorIsRandom) {
                    _generatorIsRandom = true;
                    _generatorConfig = [
                        {
                            type: Math.floor(Math.random() * Object.keys(generatorSpecs).length),
                            levels: [0],
                        }
                    ];
                }
                newSnapshots.push(getTransformedState(Object.assign(Object.assign({}, snapshotPresets), { _generatorConfig,
                    _generatorIsRandom, _snapshotId: _snapshotId !== null && _snapshotId !== void 0 ? _snapshotId : (0, uuid_1.v4)(), _snapshotVersion: (_snapshotVersion !== null && _snapshotVersion !== void 0 ? _snapshotVersion : 0) + 1 })));
            }
            snapshots = newSnapshots;
            snapshotIndex = 0;
        },
        next: () => {
            if (snapshotIndex < snapshots.length - 1)
                snapshotIndex++;
        },
        prev: () => {
            if (snapshotIndex > 0)
                snapshotIndex--;
        },
        refresh: (id) => {
            const index = getIndex(id);
            if (index !== -1) {
                const snapshot = snapshots[index];
                let _generatorIsRandom = snapshot.state._generatorIsRandom;
                let _generatorConfig = snapshot.state._generatorConfig;
                if (_generatorIsRandom) {
                    _generatorConfig = [
                        {
                            type: Math.floor(Math.random() * Object.keys(generatorSpecs).length),
                            levels: [0],
                        }
                    ];
                }
                const presets = Object.assign(Object.assign({}, snapshotPresets), { _generatorConfig,
                    _generatorIsRandom, _snapshotId: snapshots[index].state._snapshotId, _snapshotVersion: snapshots[index].state._snapshotVersion + 1 });
                snapshots[index] = getTransformedState(presets);
            }
        },
        update: (id, actionPresets = {}) => {
            var _a, _b, _c, _d, _e, _f;
            const index = getIndex(id);
            if (index !== -1) {
                const snapshot = snapshots[index];
                // Get the generator config.
                let _generatorConfig = (_a = actionPresets._generatorConfig) !== null && _a !== void 0 ? _a : snapshot.state._generatorConfig;
                const _generatorIsRandom = (_b = actionPresets._generatorIsRandom) !== null && _b !== void 0 ? _b : snapshot.state._generatorIsRandom;
                if (((_c = _generatorConfig === null || _generatorConfig === void 0 ? void 0 : _generatorConfig[0]) === null || _c === void 0 ? void 0 : _c.type) === -1) {
                    _generatorConfig = [
                        {
                            type: Math.floor(Math.random() * Object.keys(generatorSpecs).length),
                            levels: [0],
                        }
                    ];
                }
                // Check if the generator has changed.
                const oldGenerator = (_e = (_d = snapshot.state._generatorConfig) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.type;
                const newGenerator = (_f = _generatorConfig === null || _generatorConfig === void 0 ? void 0 : _generatorConfig[0]) === null || _f === void 0 ? void 0 : _f.type;
                const usingNewGenerator = oldGenerator !== newGenerator;
                // Clear the snapshot if the generator has changed.
                let presets = Object.assign({}, snapshotPresets);
                Object.entries(transforms).forEach(([prop, valueName]) => {
                    if (presets[prop] !== undefined) {
                        presets = setFieldByString(presets, valueName, presets[prop]);
                    }
                });
                snapshots[index] = getTransformedState({ _snapshotId: id, _generatorConfig, _generatorIsRandom }, actionPresets, usingNewGenerator ? {} : snapshot);
            }
        },
        updatePresets: (id, actionPresets = {}) => {
            const index = getIndex(id);
            if (index !== -1) {
                const presets = Object.assign(Object.assign(Object.assign({}, snapshotPresets), actionPresets), { _snapshotId: snapshots[index]._snapshotId });
                snapshots[index] = getTransformedState(presets);
                snapshotPresets = presets;
            }
        },
    };
    const setPresets = (indexToGet, presets) => {
        var _a;
        const snapshot = snapshots[indexToGet !== null && indexToGet !== void 0 ? indexToGet : snapshotIndex];
        for (const key of Object.keys(presets)) {
            snapshotPresets[key] = (_a = snapshot[key]) !== null && _a !== void 0 ? _a : presets[key];
        }
    };
    const dispatch = (action) => (...args) => {
        // @ts-ignore
        actions[action](...args);
        return getSnapshot(actionsById.includes(action) ? getIndex(args[0]) : undefined);
    };
    const getSnapshot = (indexToGet) => {
        var _a, _b;
        const snapshot = Object.assign({}, snapshots[indexToGet !== null && indexToGet !== void 0 ? indexToGet : snapshotIndex]);
        const index = indexToGet !== null && indexToGet !== void 0 ? indexToGet : snapshotIndex;
        const specIndex = (_b = (_a = generatorConfigs.find((gc) => gc.index === index)) === null || _a === void 0 ? void 0 : _a.types[0].type) !== null && _b !== void 0 ? _b : 0;
        const state = specs[specIndex].values.reduce((soFar, { name }) => {
            const snapshotValue = soFar[name];
            const snapshotErrors = soFar._errors.filter((v) => v.name === name);
            if (snapshotValue === undefined && snapshotErrors.length) {
                soFar[name] = { _hasErrors: true, _errors: snapshotErrors };
            }
            return soFar;
        }, snapshot.state);
        Object.entries(transforms).forEach(([prop, valueName]) => {
            state[prop] = snapshot.state[valueName];
        });
        return {
            snapshotInfo: {
                snapshot: snapshot.state,
                snapshots: snapshots.map((s) => s.state),
                snapshotIndex: index,
                snapshotId: snapshot.state._snapshotId,
                snapshotErrors: snapshot.state._errors,
            },
            state,
        };
    };
    return Object.assign({ getSnapshot }, Object.fromEntries(Object.keys(actions).map((action) => [action, dispatch(action)])));
}
exports.default = snapshotManager;
